<script setup>
import { useQuasar } from 'quasar'
import CookieDialog from './dialogs/Policies/CookieDialog.vue'
import PrivacyDialog from './dialogs/Policies/PrivacyDialog.vue'
import TermsAndConditionsDialog from './dialogs/Policies/TermsAndConditionsDialog.vue'
import { inject, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const quasar = useQuasar();
const eventBus = inject('eventBus');

const route = useRoute()
const router = useRouter()

eventBus.on('showCookiePolicy', openCookiePolicyDialog);
eventBus.on('showPrivatePolicy', openPrivacyPolicyDialog);
eventBus.on('showTermsAndConditions', openTermsAndConditionsDialog);

watch(
    () => route.hash,
    (hash) => {
        if (hash === '#PrivacyPolicy') {
            openPrivacyPolicyDialog()
        }
    },
    { immediate: true }
)

function openCookiePolicyDialog(){
    quasar.dialog({
        component: CookieDialog,
    })
}

function openPrivacyPolicyDialog(){
    quasar.dialog({
        component: PrivacyDialog,
    }).onDismiss(() => {
        if (route.hash === '#PrivacyPolicy') {
            router.replace({ hash: '' })
        }
    });
}

function openTermsAndConditionsDialog(){
    quasar.dialog({
        component: TermsAndConditionsDialog
    })
}


</script>

<template>
    <div class="row">
        <div class="row-md column-xs justify-sm-between justify-xs-center items-center content-xs-center col-12 col-lg-4 offset-lg-4">
            <a href="#"
               class="text-white"
               @click.prevent="openPrivacyPolicyDialog"
               title="Privacy Policy">Privacy Policy</a>

            <a href="#"
               class="text-white"
               @click.prevent="openCookiePolicyDialog"
               title="Cookie Policy">Cookie Policy</a>

            <a href="#"
               class="text-white"
               @click.prevent="openTermsAndConditionsDialog"
               title="Terms and Conditions">Terms and Conditions</a>
        </div>
    </div>
</template>

<style scoped>

</style>
